import { api } from "../../services/api";

export async function fetchChaveSecreta() {
  const token = localStorage.getItem("@medusapayments:access_token");

  try {
    const response = await api.get("/apikey", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
}
